// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false
// };

// DEV SERVER https://innervate-cares-dev1-api1.edlution.com.sg/api
// LOCAL http://127.0.0.1:3232/api

export const environment = {
  production: false,
  backend_server:'https://cloud-stg1-api1.activesilvers.org/api',
  api_username:'edlution',
  api_password:'199591',
  app_name:'innervate_fitness',
  app_session:'innervate_session',
  app_token:'innervate_token',
  app_version:'FE v0.6.3 BE v0.5.8 DB v30'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
